import type { ProjectVersionChange } from "@/project-history/types/types";
import type { TranslationKey } from "@/localization/hooks/use-translation";

const changeKeys = {
  initial: "history.change.initial",
  restored: "history.change.restored",
  "text-added": "history.change.text-added",
  "text-removed": "history.change.text-removed",
  "text-edited": "history.change.text-edited",
  "text-styled": "history.change.text-styled",
  "font-changed": "history.change.font-changed",
  "layers-moved": "history.change.layers-moved",
  "layers-resized": "history.change.layers-resized",
  "layers-rotated": "history.change.layers-rotated",
  "picture-added": "history.change.picture-added",
  "picture-removed": "history.change.picture-removed",
  "picture-changed": "history.change.picture-changed",
  "shapes-changed": "history.change.shapes-changed",
  "background-changed": "history.change.background-changed",
  "photo-changed": "history.change.photo-changed",
  "photo-adjusted": "history.change.photo-adjusted",
  "spine-changed": "history.change.spine-changed",
  "tracklist-changed": "history.change.tracklist-changed",
  "layout-changed": "history.change.layout-changed",
  "layers-changed": "history.change.layers-changed",
  "project-changed": "history.change.project-changed",
} satisfies Record<ProjectVersionChange["kind"], TranslationKey>;
const pageKeys = {
  cd: "history.page.cd",
  front: "history.page.front",
  frontInside: "history.page.frontInside",
  back: "history.page.back",
  backInside: "history.page.backInside",
  cover: "history.page.cover",
  coverInside: "history.page.coverInside",
} satisfies Record<NonNullable<ProjectVersionChange["pageId"]>, TranslationKey>;

export const versionDescription = ({
  changes,
  t,
  language,
}: {
  changes: ProjectVersionChange[];
  t: (key: TranslationKey, variables?: Record<string, string | number>) => string;
  language: string;
}) => {
  const labels = changes.map((change) => {
    const description = t(changeKeys[change.kind]);
    return change.pageId
      ? t("history.changeOnPage", { change: description, page: t(pageKeys[change.pageId]) })
      : description;
  });
  return (
    new Intl.ListFormat(language, { style: "short", type: "conjunction" }).format(
      labels.slice(0, 2),
    ) || t("history.change.project-changed")
  );
};
